/**
 * Names of fields that can be rendered by the Update Member Password Form Field component.
 */
export var UpdateMemberPasswordFormFieldName;
(function (UpdateMemberPasswordFormFieldName) {
    UpdateMemberPasswordFormFieldName["Password"] = "Password";
    UpdateMemberPasswordFormFieldName["CurrentPassword"] = "CurrentPassword";
    UpdateMemberPasswordFormFieldName["Captcha"] = "Captcha";
})(UpdateMemberPasswordFormFieldName || (UpdateMemberPasswordFormFieldName = {}));
